module.exports = __webpack_public_path__ + "static/media/15_FVCON_Prostetic.c1f57ee2.png";